import { useEffect, useState } from "react";
import type { RoundFeedCard } from "../../../shared/contracts/round-feed.js";
import { apiJson } from "../../api/request.js";
export function loadRoundStoryCard(id: string): Promise<RoundFeedCard> {
  return apiJson(`/api/v1/feed/rounds/${encodeURIComponent(id)}/story`);
}
export function useRoundStory(id: string, version: number) {
  const [data, setData] = useState<{ key: string; card: RoundFeedCard } | null>(
    null,
  );
  const key = `${id}:${version}`;
  useEffect(() => {
    let active = true;
    void loadRoundStoryCard(id)
      .then((card) => {
        if (active) setData({ key, card });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [key, id]);
  return data?.key === key ? data.card : null;
}
